import { Box } from '@opendoor/atoms/box';
import {
  CONTENT_PAGE_FONT_PRELOADS,
  COSMOS_ASSET_ORIGIN,
} from 'components/shared/performance/preloads';
import Head from 'next/head';

import StaticSiteFooter from './StaticSiteFooter';
import StaticSiteHeader from './StaticSiteHeader';

interface StaticSiteLayoutProps {
  slug: string;
  children: React.ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  /** Merged onto the header bar, e.g. to match a page ground other than primary. */
  headerClassName?: string;
}

const StaticSiteLayout = ({
  slug,
  children,
  hideHeader,
  hideFooter,
  headerClassName,
}: StaticSiteLayoutProps) => {
  return (
    <>
      <Head>
        <link rel="preconnect" href="https://images.opendoor.com" />
        <link rel="dns-prefetch" href="https://images.opendoor.com" />
        {COSMOS_ASSET_ORIGIN && (
          <link rel="preconnect" href={COSMOS_ASSET_ORIGIN} crossOrigin="anonymous" />
        )}
        {COSMOS_ASSET_ORIGIN && <link rel="dns-prefetch" href={COSMOS_ASSET_ORIGIN} />}
        {CONTENT_PAGE_FONT_PRELOADS.map((preload) => (
          <link
            key={preload.href}
            rel="preload"
            href={preload.href}
            as={preload.as}
            type={preload.type}
            crossOrigin={preload.crossOrigin}
          />
        ))}
      </Head>
      <Box className="relative block">
        {!hideHeader && <StaticSiteHeader slug={slug} className={headerClassName} />}
        {/* eslint-disable @opendoor/no-html-elements */}
        <main tabIndex={-1}>
          <Box className="m-0 block w-full">{children}</Box>
        </main>
        {!hideFooter && <StaticSiteFooter />}
      </Box>
    </>
  );
};

export default StaticSiteLayout;
